<template>
  <div class="flex nested-menu-tab-button-container">
    <vs-button
      color="success"
      type="filled"
      icon-pack="feather"
      icon="icon-send"
      size="small" @click="openSendSmsPopup()">
      {{ $t('send_sms') }}
    </vs-button>
    <nested-menu-tab-button :title="$t('history')" icon="icon-list" route="messages.history"></nested-menu-tab-button>
    <nested-menu-tab-button :title="$t('category')" icon="icon-grid" route="messages.category"></nested-menu-tab-button>
    <nested-menu-tab-button :title="$t('callback_number')" icon="icon-phone" route="messages.callbackNumber"></nested-menu-tab-button>
    <nested-menu-tab-button :title="$tc('template', 2)" icon="icon-clipboard" route="messages.template"></nested-menu-tab-button>
  </div>
</template>

<script>
import NestedMenuTabButton from '@/components/navigations/NestedMenuTabButton'
import {EventBus} from '@/../eventbus'

export default {
  name: 'Shared.Messages.TabNav',
  components: {
    NestedMenuTabButton
  },
  methods: {
    openSendSmsPopup () {
      EventBus.$emit('initSendSmsPopup')
    }
  }
}
</script>

<style scoped>

</style>
